import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ApiHttpResponse, User } from '@kinomap-dev/ng-ui-lib';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService, LanguageService, SwarmLoginService } from 'app/services';
import { selectProfileData } from 'app/store/me/me.selectors';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment.local';

@Component({
  imports: [TranslateModule],
  selector: 'app-upload-page',
  standalone: true,
  styleUrl: './upload.page.component.scss',
  template: `
    <section>
      @if (isLogged) {
        <iframe
          id="upload-iframe"
          title="upload video"
          width="100%"
          [src]="safeUploadUrl"></iframe>
      } @else {
        <h3 translate>browse.upload.not-logged-title</h3>
        <p translate>browse.upload.not-logged-msg</p>
        <div>
          <a class="btn-secondary" translate
            >browse.upload.not-logged-FAQ-btn</a
          >
        </div>
      }
    </section>
  `,
})
export class UploadPageComponent implements OnInit {
  private authService: AuthService = inject(AuthService);
  private sanitizer: DomSanitizer = inject(DomSanitizer);
  private languageService: LanguageService = inject(LanguageService);
  private http: HttpClient = inject(HttpClient);
  private store: Store = inject(Store);
  private loginService: SwarmLoginService = inject(SwarmLoginService);
  private route: ActivatedRoute = inject(ActivatedRoute);

  private subscriptions: Subscription[] = [];
  private uploadUrl: string = environment.oldWebsite.url.upload;

  isLogged: boolean = false;
  safeUploadUrl: SafeResourceUrl;

  ngOnInit(): void {
    if (this.route.snapshot.queryParams['token']) {
      return;
    }

    this.isLogged = this.authService.isLogged();
    this.subscriptions = [
      ...this.subscriptions,
      this.store.select(selectProfileData).subscribe((user: User) => {
        if (user && localStorage.getItem('user_access_token').length === 120) {
          const lang: string = ['fr', 'en'].includes(
            this.languageService.format()
          )
            ? this.languageService.format()
            : 'en';
          this.uploadUrl = this.uploadUrl
            .replace('{lang}', lang)
            .replace(
              '{userAppToken}',
              localStorage.getItem('user_access_token')
            );
          this.safeUploadUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.uploadUrl
          );
        } else if (user) {
          return this.getOldAccessToken();
        }
      }),
    ];
  }

  getOldAccessToken(): void {
    this.subscriptions.push(
      this.http
        .get<
          ApiHttpResponse<{ id: number; old_access_token: string }>
        >(environment.api.getOldAccessToken)
        .subscribe({
          next: (
            res: ApiHttpResponse<{ id: number; old_access_token: string }>
          ) => {
            const lang: string = ['fr', 'en'].includes(
              this.languageService.format()
            )
              ? this.languageService.format()
              : 'en';
            this.uploadUrl = this.uploadUrl
              .replace('{lang}', lang)
              .replace('{userAppToken}', res.data.old_access_token);
            this.safeUploadUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
              this.uploadUrl
            );
          },
          error: (err: HttpErrorResponse) => {
            console.error(err);
            if (err.status === 401) {
              this.loginService.redirectToOauth();
            }
          },
        })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }
}
